export function paramsFromQuery(mainParams, queryParams){
  let bs = queryParams.bs
  let search_query = queryParams.search_query
  let page = queryParams.pageNo
  let as = queryParams.as
  let sortKey = queryParams.sortKey;
  let sortDir = queryParams.sortDir;
  if(bs){
    mainParams['as'] = true
    mainParams['bs'] = bs;
  }
  if (search_query) {
    mainParams['search_query'] = search_query;
  }
  if(page){
    mainParams['page'] = page
  }
  if(as){
    mainParams['as'] = true
  }
  if(sortKey){
    mainParams['key'] = decodeSortKey(sortKey)
    mainParams['sort'] = sortDir || 'asc'
  }
}

export function decodeMeetingParams(Meeting){
  let senddata = new FormData();
  if (Meeting.uuid) {
    senddata.append(['uuid'], Meeting.uuid)
  }
  if (Meeting.lead_uuid) {
    senddata.append(['lead_uuid'], Meeting.lead_uuid.uuid)
  }

  senddata.append(['date'], Meeting.date)
  if (Meeting.attachment) {
    senddata.append(['attachment'], Meeting.attachment)
  }
  senddata.append(['comment'], Meeting.comment)
  senddata.append(['location'], Meeting.location)
  if ( Meeting.executive_image) {
    senddata.append(['executive_image'], Meeting.executive_image,Meeting.executive_image.name)
  }

  if (Meeting.recording !== null || "") {
    senddata.append(["recorded_audio"], Meeting.recording);
    senddata.append(["recorded_audio_duration"], Meeting.recorded_audio_duration);
  }
  // senddata.append(['meeting_executive_lat'], Meeting.meeting_executive_lat)
  // senddata.append(['meeting_executive_long'], Meeting.meeting_executive_long)
  
  return senddata;
}


export function decodeSortKey(key){
  if(key === "ncd"){
    return "next_call_date_and_time";
  }
  return key;
}

export const MEETING_SCHEDULED = 32
export const EMPANELMENT_STATUS_IDS = [36, 38, 39,77,70]